import 'angular';

import restButtonDirective from '../rest-button';

import addOptions from './add';
import deleteDirective from './delete';
import manageDirective from './manage';

const MODULE_NAME = 'daupler.incidents.components.buttons.labels';

var app = angular.module(MODULE_NAME, []);

app.directive('addLabel', restButtonDirective(addOptions));
app.directive('deleteLabel', deleteDirective);
app.directive('manageLabels', manageDirective);

export default MODULE_NAME;
